/* eslint-disable no-unused-vars */
import React from "react";
import FrontBanner from "@/assets/images/front-banner.svg";
import { Link } from "react-router-dom";
import "./index.scss";
import MembershipTab from "./components/MembershipTab";
import { ROUTESLIST } from "@/static/urls";


const ServicesPage = (props, { userDashboardView = false }) => {

    return (
        <main className="page product-page">
            <div
                className="product-section"
                style={userDashboardView ? {margin: "0rem"} : {margin: "5rem"}}
            >

                <div
                    className="product-header"
                    style={{
                        justifyContent: "center",
                    }}
                >

                    <Link className="back-to-home-section-image center" to={ROUTESLIST.HOME}>
                        <img src="https://ample-samples.s3.us-east-2.amazonaws.com/app/front-banner.svg" alt="front-banner"/>
                    </Link>
                </div>
                <div className="video-responsive-container">
                <iframe width="560" height="315" src="https://www.youtube.com/embed/ZuQSNr4v8Wk?si=qPdQz8q5IVSM17Nk"
                        title="Ample Samples Service Explanation"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen></iframe>
                </div>
                <div className="plan-header">
                    <p>
                        For brands, filmmakers, artists and labels who clear multiple songs yearly.
                        <br/>
                        Ideal for professionals who are managing recurring sync and sample projects.
                    </p>
                    <h3>
                        Built for independent music professionals who want faster, smarter, and more affordable clearances.
                    </h3>
                    <p className="save-up-to">
                        <b>Upgrade to Pro & Unlock 10 More Clearances</b><br/>
                        You’re already saving with Lite — upgrade for $250 more and clear 15 total songs, saving $7,000 overall.
                    </p>
                </div>

                <MembershipTab buttonTitle="Login" />
                <div className="divider"></div>
                <div className="why-choose-section">
                    <div className="why-choose-center">
                        <h3>Why Choose Ample Samples™?</h3>
                        <p>
                            At Ample Samples™, we understand the complexities and challenges
                            faced by music creators, producers, and media companies when it
                            comes to licensing and clearing samples. Our all-in-one solution
                            streamlines this process, allowing you to focus on your creativity
                            while we handle the legal intricacies. Here's why we stand out:
                        </p>
                    </div>
                </div>
                {/*<div className="plan-detail-section">
                    <h3>Which Plan is for me?</h3>
                    <div className="card-parent">
                        {plans.map((plan) => (
                            <div className="plan-card-details" key={plan.id}>
                                <h3>{plan.name}:</h3>
                                <p>{plan?.details}</p>
                            </div>
                        ))}
                    </div>
                </div>*/}
            </div>
        </main>
    );
};

export default ServicesPage;
